<template>
  <div class="wrapper">
    <AppModalProfileCharCounter v-if="maxLength" :value="modelValue" :max-length="maxLength" :style="{visibility: isFocused ? 'visible' : 'hidden'}" />
    <textarea
      ref="textareaRef"
      class="text-area"
      :value="modelValue"
      :placeholder="placeholder"
      :disabled="disabled"
      :style="{borderRadius: isFocused ? '0' : '12px'}"
      @input="$emit('update:modelValue', $event.target.value)"
      @focus="isFocused = true; $emit('focus')"
      @blur="isFocused = false; $emit('blur')"
    />
  </div>
</template>

<script setup>
import {ref} from "vue";
import AppModalProfileCharCounter from "@/components/App/Modal/Profile/CharCounter";

defineProps({
  modelValue: {type: String, default: ""},
  placeholder: {type: String, default: ""},
  disabled: {type: Boolean, default: false},
  maxLength: {type: Number, default: 0},
});
defineEmits(["update:modelValue", "focus", "blur"]);

const textareaRef = ref(null);
const isFocused = ref(false);

defineExpose({focus: () => textareaRef.value?.focus()});
</script>

<style scoped>
.wrapper {
  display: flex;
  flex-direction: column;
}
.text-area {
  width: 100%;
  min-height: 120px;
  padding: 10px;
  border: 1px solid var(--border-color);
  border-radius: 12px;
  outline: none;
  font-size: 13px;
  font-family: inherit;
  resize: vertical;
  background: white;
  box-sizing: border-box;
  color: rgba(0, 0, 0, 0.75);
}
.text-area:focus {
  border-color: #2563eb;
}
.text-area:disabled {
  opacity: 0.6;
}
.text-area::placeholder {
  font-weight: 300;
  font-style: italic;
  color: rgba(0, 0, 0, 0.4);
}
.text-area:focus::placeholder {
  color: rgba(0, 0, 0, 0.35);
}
</style>
